namespace $.$$ {

	export class $shm_ba_summary extends $.$shm_ba_summary {

		cards() {
			const table = this.table() as $shm_ba_data_table | null
			return table?.head.map( ( _, index )=> this.Card( index ) ) ?? []
		}

		card_title( index: number ) {
			return ( this.table() as $shm_ba_data_table | null )?.head[ index ] ?? ''
		}

		card_metric( index: number ) {
			const title = this.card_title( index )
			return title === 'Всего сообщений' ? 'Сообщений' : title
		}

		card_selected( index: number ) {
			return this.card_metric( index ) === this.selected()
		}

		pick( index: number, next?: Event ) {
			if( next === undefined ) return null
			this.selected( this.card_metric( index ) )
			return next
		}

		card_value( index: number ) {
			const table = this.table() as $shm_ba_data_table | null
			return this.format_number( table?.rows[0]?.[ index ] )
		}

		format_number( value: $shm_ba_data_cell ) {
			const text = String( value ?? '' )
			if( !/^-?\d{5,}$/.test( text ) ) return text
			return text.replace( /\B(?=(\d{3})+(?!\d))/g, ' ' )
		}

	}

}
